import { themeVars } from '@synoptic/ui-kit/theme/vars.js';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.js';
import { ellipsis } from '@synoptic/ui-kit/utility.css.js';
import { style } from '@vanilla-extract/css';
import { baseTextEditorTheme } from '../../themes/base.css';

export const linkEditor = style({
  display: 'flex',
  position: 'absolute',
  top: 0,
  left: 0,
  maxWidth: 400,
  width: '100%',
  opacity: 0,
  backgroundColor: themeVars.container.primary.background.idle,
  outline: `1px solid ${themeVars.container.border.default} `,
  outlineOffset: '-1px',
  boxShadow:
    '0px 0px 2px 0px rgba(81,97,108,.3),0px 4px 6px 0px rgba(81,97,108,.05),0px 10px 26px 0px rgba(81,97,108,.15)',
  borderRadius: borderRadius.r8,
  transition: 'opacity 0.2s',
  willChange: 'transform',
  padding: space.s4,
  gap: space.s4,
});

export const linkEditorInput = style({
  flexGrow: 1,
});

export const linkEditorActions = style({
  display: 'flex',
  alignItems: 'center',
});

export const linkView = style({
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',
  flexGrow: 1,
  justifyContent: 'space-between',
});

export const linkViewText = style([baseTextEditorTheme.link, ellipsis]);

export const linkViewActions = style({
  display: 'flex',
  alignItems: 'center',
});
